import axios from 'axios';

export default class SpotifyAPI{
    constructor(token){
        if(!token){
            throw new Error(`No access token provided`)
        }
        this.access_token = token;
        this.instance = axios.create({
            baseURL: 'https://api.spotify.com/v1/',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
    }

    get = async (url) => {
        try{
            let response = await this.instance.get(url);
            return response.data;
        }catch(e){
            throw new Error(e);
        }
    }
}
